import React from 'react';
import SidebarProfile from "./SidebarProfile";
import { useOverviewContext } from "../../context/OverviewContext";


interface SidebarProps {
    onItemClick?: () => void;
    onSwitchStudent?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onItemClick, onSwitchStudent }) => {
    const {
        loggedInUser,
        students,
        teacherSchools,
        userRoleVal,
        loading,
        error
        } = useOverviewContext();

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    const userName = `${loggedInUser?.fname || ''}`;
    const role = userRoleVal;
    const showSwitchButton =
        userRoleVal === 'TEACHER' ? teacherSchools.length > 1 : students.length > 1;
    const type = showSwitchButton ? 'multi-student-lc' : 'single-student-lc';

    return (
        <>
            <aside className={`sidebar sidebar--${type}`}>
                <SidebarProfile
                    userName={userName}
                    role={role}
                    showSwitchButton={showSwitchButton}
                    type={type}
                    onItemClick={onItemClick}
                    onSwitchStudent={onSwitchStudent}
                />
            </aside>
        </>
    );
};

export default Sidebar;
